import React from "react";
import { cn } from "../../utils/cn";

interface BaseInputProps {
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  className?: string;
  label?: string;
  errors?: string;
  name?: string;
}

interface TextInputProps extends BaseInputProps {
  type: "text" | "password" | "number";
  placeholder: string;
}

interface DateInputProps extends BaseInputProps {
  type: "date";
  placeholder?: string;
}

type InputProps = TextInputProps | DateInputProps;

const Input: React.FC<InputProps> = ({
  value,
  onChange,
  placeholder,
  className,
  type,
  label,
  errors,
  name,
}) => {
  return (
    <div className="flex w-full flex-col gap-2">
      {label && (
        <label className="text-cream-800 dark:text-cream-400 text-sm font-medium">
          {label}
        </label>
      )}
      <input
        type={type}
        name={name}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        className={cn(
          "border-cream-500 placeholder-cream-600 selection:bg-peach-300 dark:placeholder-cream-500 text-cream-950 dark:bg-cream-800 dark:text-cream-100 w-full rounded border font-medium",
          className,
        )}
      />
      {errors && (
        <span className="text-peach-600 dark:text-peach-400 text-sm font-semibold">
          {errors}
        </span>
      )}
    </div>
  );
};

export default Input;
